import { memo } from "react";
import { Row } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { CheckIcon } from "@icons";

interface Props {
    row: Row<ViewTableFeatures, TransactionListItem>;
}

export const ReconciliationStatusCell = memo(({ row }: Props) => {
    const transaction = row.original;

    if (!transaction.reconciledInId) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <Tooltip side="top" content="Transaction reconciled">
                <span>
                    <CheckIcon className="icon-color-blue-600" />
                </span>
            </Tooltip>
        </ViewTableCell>
    );
});
ReconciliationStatusCell.displayName = "ReconciliationStatusCell";
